// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".switching-img{position:relative}.switching-img .bullets{background-color:#fff;border-radius:3px;bottom:5px;display:flex;gap:4px;justify-content:stretch;left:50%;padding:2px 4px;position:absolute;transform:translate(-50%)}.switching-img .bullet{background-color:#504e4d;border-radius:2px;height:4px;opacity:.5;transition:opacity .1s ease;width:35px}.switching-img .bullet.active{opacity:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
